import Vue from 'vue'
import Router from 'vue-router'
import ShareInfo from '@/components/shareInfo'
import DownLoad from '@/components/downLoad'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/share',
      name: 'shareInfo',
      component: ShareInfo
    },{
      path: '/downLoad',
      name: 'downLoad',
      component: DownLoad
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js